import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8c1a892c&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAuthorHero: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogAuthorHero.vue').default,BlogListPost: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogListPost.vue').default,CommonPagination: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonPagination.vue').default,BContainer: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/BContainer.vue').default})
